// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3M_eE"};